import { isEmpty, omit } from 'ramda'
import { useFilter, useFilterActions, useFilterState } from '@btime/react-contexts'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import { useOpenEditScreenViewModal } from '../../utils/routes/modals/modalsActions'
import CleanFilterButton from '../../components/filter/CleanFilterButton'
import LineSeparator from '../../packages/kiti/components/helpers/LineSeparator'
import Link from '../../packages/kiti/components/actions/Link'
import ScreenViewsDropdown from './select/ScreenViewsDropdown'
import Separator from '../../packages/kiti/components/helpers/Separator'
import Text from '../../packages/kiti/components/presentation/Text'

const ScreenViewFilterBar = ({ open, children, screen, lineOnTop, ignoreFields }) => {
  const saveView = useOpenEditScreenViewModal()
  const filters = omit(ignoreFields || [], useFilter())
  const { touched, view, filter } = useFilterState()
  const { setView } = useFilterActions()
  const hasFilters = !isEmpty(filters)

  // useLocalStorageWatcher(`${screen}_LAST_VIEW`, { view, filter })

  if (!open) return false

  const openViewModal = () => {
    saveView({ view: { ...view, screen, filters }, onSave: setView })
  }

  return (
    <>
      {!!lineOnTop && <LineSeparator weight={4} color="light2" />}
      {!lineOnTop && <Separator weight={2.5} />}
      <Grid gutter={0.9} align="center">
        <Col>
          <Link>
            <Grid align="center" gutter={0.1}>
              <Separator weight={1} vertical />
              <ScreenViewsDropdown screen={screen} ignoreFields={ignoreFields} />
            </Grid>
          </Link>
        </Col>

        {children}

        <Col flex={1} />

        {hasFilters && touched && (
          <Col>
            <Text color="dark1" onClick={openViewModal} bold>
              Salvar visão
            </Text>
          </Col>
        )}
        <Col>
          <CleanFilterButton ignoreFields={ignoreFields} />
        </Col>
      </Grid>
      {!lineOnTop && <LineSeparator weight={4} color="light2" />}
    </>
  )
}

export default ScreenViewFilterBar
